export enum LiveRouteStatus {
    /// <summary>
    /// The is the default status, from when the shipment/pickup is created until it's either scanned by the conveyor (delivery)
    /// or a pickup is created (pickups)
    /// </summary>
    DataReceived = 0,

    /// <summary>
    /// From when the shipment/pickup is created until the scan before route is done
    /// </summary>
    InTransit = 1,

    /// <summary>
    /// Once the driver is done loading his truck, this is the status
    /// </summary>
    InRoute = 2,

    /// <summary>
    /// If the driver has not been able to complete the transaction, but the shipment is not cancelled, for example
    /// codes 5, 11, 40, 44, etc
    /// </summary>
    Failed = 3,

    /// <summary>
    /// If the driver has been able to complete the pickup or delivery successfully
    /// </summary>
    Successful = 4,

    /// <summary>
    /// If the pickup or delivery gets cancelled (code 500) before any exception code is entered
    /// </summary>
    Deleted = 5,

    /// <summary>
    /// If a code 3, 9, 47, etc is entered from tpsl_route
    /// </summary>
    Postponed = 6,

    /// <summary>
    /// When we want to put parcels into a manifest we set this type
    /// </summary>
    ToBeManifested = 7,
}
